export default "Lav jeres egne seje mini stammebåde af udhulet hyld og prøv kræfter med et håndværk fra jægerstenalderen i miniformat. ";